/**
 * Carga
 * @author Simpli CLI generator
 */
import {
  $, bool, cep, cnpj, cpfOrCnpj,
  HttpBody,
  HttpIgnore,
  ID,
  RequestExclude,
  Resource,
  Resp,
  ResponseFill,
  ResponseSerialize, success,
  ValidationMaxLength,
  ValidationRequired,
  WholeCollection,
} from 'simpli-web-sdk'
import {uniq} from 'lodash'
import moment from 'moment'
import Sistema from '@/model/resource/Sistema'
import Responsavel from '@/model/resource/Responsavel'
import Auditoria from '@/model/resource/Auditoria'
import Endereco from '@/model/resource/Endereco'
import Motorista from '@/model/resource/Motorista'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import ResponsavelFilial from '@/model/resource/ResponsavelFilial'
import StatusCarga from '@/model/resource/StatusCarga'
import CargaResponsavel from '@/model/resource/CargaResponsavel'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import CargaRequest from '@/model/request/CargaRequest'
import {DeliveryAddressOption} from '@/enums/DeliveryAddressOption'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliveryEvent} from '@/enums/DeliveryEvent'
import CargaSchema from '@/schema/Carga.schema'
import * as Helper from '@/helpers'
import CargaDanfeRequest from '@/model/request/CargaDanfeRequest'
import TipoPessoaRecebedor from '@/model/resource/TipoPessoaRecebedor'
import PosicaoMotorista from '@/model/resource/PosicaoMotorista'
import ListReportParam from '@/model/request/ListReportParam'
import CentroDeCusto from '@/model/resource/CentroDeCusto'
import {CargaInfo} from '@/model/resource/CargaInfo'
import {InfoCargaAdicional} from '@/model/resource/InfoCargaAdicional'
import DevolverNota from '@/model/request/DevolverNota'
import CodigoBarra from '@/model/resource/CodigoBarra'
import {CargaConcreto} from '@/model/resource/CargaConcreto'
import {TipoNotificacao} from '@/enums/TipoNotificacao'
import {TipoNotificacaoCarga} from '@/enums/TipoNotificacaoCarga'
import {CargaInfo2} from '@/model/resource/CargaInfo2'
import {Exclude} from 'class-transformer'

export default class Carga extends Resource {

  static async persistCargaSla(request?: Carga[], spinner = 'persistCarga'): Promise<Resp<number[]>> {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/carga/sla`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaOrderNumber(request?: Carga[], spinner = 'persistCarga'): Promise<Resp<number[]>> {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/carga/pedido`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaIssueDate(request?: Carga[], spinner = 'persistCarga'): Promise<Resp<number[]>> {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/carga/emissao`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaComDanfe(request?: CargaDanfeRequest, spinner = 'persistCarga'): Promise<Resp<any>> {
    const fetch = async () => await new HttpBody<any>(Object).POST(`/user/carga/lote-com-danfe`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaSemDanfe(request?: CargaDanfeRequest, spinner = 'persistCarga'): Promise<Resp<number[]>> {
    const fetch = async () => await new HttpBody<number[]>(Array).POST(`/user/carga/lote-sem-danfe`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaNotfis(request?: string, spinner = 'persistCarga'): Promise<Resp<any>> {
    const fetch = async () => await new HttpBody<any>(Object).POST(`/user/carga/notfis`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaCte(request?: CargaDanfeRequest, spinner = 'persistCarga'): Promise<Resp<any>> {
    const fetch = async () => await new HttpBody<any>(Object).POST(`/user/carga/cadastro-lote-cte`, request)
    return await $.await.run(fetch, spinner)
  }

  static async persistCargaCteNfs(request?: CargaDanfeRequest, spinner = 'persistCarga'): Promise<Resp<any>> {
    const fetch = async () => await new HttpBody<any>(Object).POST(`/user/carga/cadastro-lote-cte-nfs`, request)
    return await $.await.run(fetch, spinner)
  }

  static async associarMotoristaCarga(request: CargaRequest, spinner = 'associarMotoristaCarga') {
    request.viaPainel = true
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/motorista/associacao`, request)
    return await $.await.run(fetch, spinner)
  }

  static async desassociarMotoristaCarga(request: CargaRequest, spinner = 'associarMotoristaCarga') {
    request.viaPainel = true
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/motorista/desassociacao`, request)
    return await $.await.run(fetch, spinner)
  }

  static async removerCargaEmLote(request: CargaRequest, spinner = 'removerCargaEmLote') {
    request.viaPainel = true
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/remocao-em-lote`, request)
    return await $.await.run(fetch, spinner)
  }

  static async finalizarCargaEmLote(request: CargaRequest, spinner = 'finalizarCargaEmLote') {
    request.viaPainel = true
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/finalizacao-em-lote`, request)
    return await $.await.run(fetch, spinner)
  }

  static async setCargaFinalizadaParaNaoIniciada(request: DevolverNota, spinner = 'setCargaFinalizadaToNaoIniciada') {
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/set-finished-carga-to-pending`, request)
    return await $.await.run(fetch, spinner)
  }

  @Exclude()
  readonly $name: string = 'Carga'

  @Exclude()
  readonly $endpoint: string = '/user/carga{/id}'

  get $schema() {
    return CargaSchema(this)
  }

  get $id() {
    return this.idCargaPk
  }

  set $id(val: ID) {
    this.idCargaPk = val
  }

  get distanciaParaDestinoEmMetrosFormatted() {
    if (this.distanciaParaDestinoEmMetros != null) {
      return `${(this.distanciaParaDestinoEmMetros / 1000).toFixed(1)}km`
    }
    return null
  }

  get ultimaDuracaoParaDestinoEmSegundosFormatted() {
    if (this.duracaoParaDestinoEmSegundos != null) {
      return new Date(this.duracaoParaDestinoEmSegundos * 1000)
        .toISOString()
        .substr(11, 5)
        .replace(/:/, 'h')
    }
    return null
  }

  @Exclude()
  @HttpIgnore()
  allMotorista = new WholeCollection(Motorista)

  @Exclude()
  @HttpIgnore()
  allMotoristaSimplifiedList = Helper.ItrackCollection.allMotoristaSimplifiedList

  @Exclude()
  @HttpIgnore()
  allMotoristaFiltro = Helper.ItrackCollection.allMotoristaFiltro

  @Exclude()
  @ResponseSerialize(Sistema)
  sistema1: Sistema | null = null

  @Exclude()
  @ResponseSerialize(Sistema)
  sistemaRemovedor: Sistema | null = null

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  @ResponseSerialize(CargaDestinatario)
  destinatario = new CargaDestinatario()

  @ResponseSerialize(CargaResponsavel)
  embarcador = new CargaResponsavel()

  @ResponseSerialize(CargaResponsavel)
  transportador = new CargaResponsavel()

  @ResponseSerialize(Motorista)
  motorista = new Motorista()

  @Exclude()
  @ResponseSerialize(Auditoria)
  auditoria = new Auditoria()

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  @ResponseSerialize(TipoOcorrencia)
  tipoOcorrencia: TipoOcorrencia | null = null

  @Exclude()
  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial1: ResponsavelFilial | null = null

  @Exclude()
  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial2: ResponsavelFilial | null = null

  @Exclude()
  @ResponseSerialize(Sistema)
  sistemaCriador: Sistema | null = null

  @Exclude()
  @ResponseSerialize(Sistema)
  sistemaFinalizador: Sistema | null = null

  @ResponseFill('status')
  @ResponseSerialize(StatusCarga)
  statusCarga: StatusCarga | null = null

  @ResponseSerialize(TipoPessoaRecebedor)
  tipoPessoaRecebedor: TipoPessoaRecebedor | null = null

  @Exclude()
  posicaoMotorista: PosicaoMotorista | null = null

  centroDeCusto: CentroDeCusto | null = null

  // Somente usado para Cielo
  @ResponseSerialize(InfoCargaAdicional)
  cargaInfoAdicional: InfoCargaAdicional | null = null

  @ResponseSerialize(CargaConcreto)
  cargaConcreto: CargaConcreto | null = null

  @Exclude()
  @ResponseSerialize(Responsavel)
  responsavelCriador: Responsavel | null = null

  @Exclude()
  @ResponseSerialize(Motorista)
  motoristaCriador: Motorista | null = null

  idCargaPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(255)
  danfe: string = ''

  @ValidationMaxLength(255)
  nroNotaFiscal: string = ''

  dataEmissaoDanfe: string | null = null

  dataInicioEntrega: string | null = null

  dataFinalizacao: string  | null = null

  dataCriacao: string | null = null

  qtdPaleteEntregue: number | null = null

  qtdPaleteRetirado: number | null = null

  observacao: string | null = null

  pontoReferenciaEntrega: string | null = null

  latitudeEntrega: number | null = null

  longitudeEntrega: number | null = null

  nomeRecebedor: string | null = null

  documentoRecebedor: string | null = null

  devolvida: boolean | null = null

  rgRecebedor: string | null = null

  @Exclude()
  ativo: boolean = false

  @Exclude()
  idCargaApp: string | null = null

  latitudeCheckIn: number | null = null

  longitudeCheckIn: number | null = null

  dataCheckIn: string | null = null

  dataPrevisao: string | null = null

  codigoBarra: string | null = null

  possuiDanfe: boolean | null = null

  slaDias: string | null = null

  slaDiasReal: string | null = null

  slaStatus: string | null = null

  slaError: boolean | null = null

  placaVeiculo: string | null = null

  tipoVeiculo: string | null = null

  nomeMotorista: string | null = null

  cpfMotorista: string | null = null

  nomeEmbarcador: string | null = null

  idResponsavelCriadorFk: ID = 0

  criadoViaPainel: boolean | null = null

  idMotoristaCriadorFk: ID = 0

  serialNumber: string | null = null

  cdCorreio: string | null = null

  get allCodigoBarras(): string[] {
    return this.codigoBarraList
      .map((it) => it.codigo)
      .filter((it) => it) as string[]
  }

  get showCodigoBarras(): boolean {
    return this.codigoBarraList.length > 0
  }

  get allCodigoBarrasInText() {
    return this.allCodigoBarras.join(', ')
  }

  @ResponseSerialize(CodigoBarra)
  codigoBarraList: CodigoBarra[] = []

  cte: string | null = null

  replicarCTE: boolean | null = null

  distanciaParaDestinoEmMetros: number | null = null

  duracaoParaDestinoEmSegundos: number | null = null

  protocolSsw: string | null = null

  @Exclude()
  finalizadoViaWeb: boolean = false

  dataBaixaSistema: string | null = null

  checkListComponentes: string | null = null

  checkListAtendimento: string | null = null

  @Exclude()
  dataRemocao: string | null = null

  distanciaCheckInEmMetros: number | null = null

  distanciaEntregaEmMetros: number | null = null

  @Exclude()
  reprocessarRedesul: boolean = false

  checkinStatus: boolean | null = null

  entregaStatus: boolean | null = null

  fotosComprovantes: string[] = []

  fotosOcorrencia: string[] = []

  fotosInicio: string[] = []

  // IBMP
  fotosProcesso: string[] = []

  // Atlas
  fotosEpiFerramentas: string[] = []
  fotosLacresECaminhaoDeslonado: string[] = []
  fotosEspelhos: string[] = []
  fotosGuias: string[] = []
  fotosPedrasDoContrapeso: string[] = []
  fotosVolumesArmazenados: string[] = []

  idEmbarcadorCacheFk: ID = 0

  idTransportadorCacheFk: ID = 0

  sigla: string | null = null

  xpedido: string | null = null

  @Exclude()
  hash: string | null = null

  @Exclude()
  urlVisitante: string | null = null

  tentativaIndex: number | null = null

  tentativaTotal: number | null = null

  nroFotosOcorrencia: number | null = null

  nroComprovantes: number | null = null

  nroFotosInicio: number | null = null

  @ResponseSerialize(CargaInfo)
  cargaInfo: CargaInfo | null = null
  // Estes atributos estao em CargaInfo e duplicados aqui para facilitar em algumas validacoes
  // e/ou acesso no front end para o cadastro em lote
  nroCte: string | null = null
  outroDocumentoRecebedor: string | null = null
  observacaoColeta: string | null = null
  notificacaoSmsAtlas: string | null = null
  notificacaoEmailAtlas: string | null = null
  dataPrevisaoAtualizada: string | null = null
  observacaoPrevisao: string | null = null

  @ResponseSerialize(CargaInfo2)
  cargaInfo2: CargaInfo2 | null = null
  observacaoEntrega: string | null = null
  idTipoNotificacaoCargaFk: number | null = null

  get urlCielo() {
    return (this.urlVisitante || '').replace('/get', '/getCargaEspecial')
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }

  set idEnderecoFk(idEnderecoFk: ID) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = idEnderecoFk
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }

  set idMotoristaFk(idMotoristaFk: ID) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = idMotoristaFk
  }

  get idOcorrenciaFk() {
    if (!this.tipoOcorrencia) return 0
    return this.tipoOcorrencia.$id
  }
  set idOcorrenciaFk(idTipoOcorrenciaFk: ID) {
    if (!this.tipoOcorrencia) this.tipoOcorrencia = new TipoOcorrencia()
    this.tipoOcorrencia.$id = idTipoOcorrenciaFk
  }

  idUltimaPosicaoMotoristaFk: ID = 0

  idSistemaCriadorFk: ID = 0

  idSistemaFinalizadorFk: ID = 0

  idSistemaRemovedorFk: ID = 0

  idRemovedorFk: ID = 0

  idUltimaAuditoriaFk: ID = 0

  idFilialEmbarcadorFk: ID = 0

  idFilialTransportadorFk: ID = 0

  idStatusFk: ID = 0

  @RequestExclude()
  addressOption = DeliveryAddressOption.RECEIVER_ADDRESS

  diasAtraso: number | null = null

  get motoristaCel() {
    return this.motorista.celular || this.motorista.telefoneFixo
  }

  get mostrarEnderecoLatLng() {
    if (this.endereco && this.endereco.latitude) {
      return true
    }
    if (this.destinatario && this.destinatario.endereco && this.destinatario.endereco.latitude) {
      return true
    }
    return false
  }

  get mapLinkCheckIn() {
    if (this.latitudeCheckIn && this.longitudeCheckIn) {
      if (this.checkinStatus !== undefined && this.checkinStatus !== null) {
        return `https://www.google.com.br/maps/search/?api=1&query=${this.latitudeCheckIn},${this.longitudeCheckIn}`
      }
    }
    return ''
  }

  get localAuditCheckIn() {
    if (this.statusCarga && this.statusCarga.idStatusPk === 3) {
      if (this.latitudeCheckIn) {
        if (this.checkinStatus !== undefined && this.checkinStatus !== null) {
          return this.checkinStatus ? $.t('app.approved') : $.t('app.decline')
        }
        return $.t('app.notInformed')
      }
      return $.t('app.notInformed')
    }
    return $.t('app.pendingDelivery')
  }

  get localAuditCheckInTagClass() {
    if (this.statusCarga && this.statusCarga.idStatusPk === 3) {
      if (this.latitudeCheckIn) {
        if (this.checkinStatus !== undefined && this.checkinStatus !== null) {
          return this.checkinStatus ? 'success' : 'danger'
        }
        return 'warning'
      }
      return 'warning'
    }
    return 'default'
  }

  get mapLinkDelivery() {
    if (this.latitudeEntrega && this.longitudeEntrega) {
      if (this.entregaStatus !== undefined && this.entregaStatus !== null) {
        return `https://www.google.com.br/maps/search/?api=1&query=${this.latitudeEntrega},${this.longitudeEntrega}`
      }
    }
    return ''
  }

  get localAuditDelivery() {
    if (this.statusCarga && this.statusCarga.idStatusPk === 3) {
      if (this.latitudeEntrega) {
        if (this.entregaStatus !== undefined && this.entregaStatus !== null) {
          return this.entregaStatus ? $.t('app.approved') : $.t('app.decline')
        }
        return $.t('app.notInformed')
      }
      return $.t('app.notInformed')
    }
    return $.t('app.pendingDelivery')
  }

  get localAuditDeliveryTagClass() {
    if (this.statusCarga && this.statusCarga.idStatusPk === 3) {
      if (this.latitudeEntrega) {
        if (this.entregaStatus !== undefined && this.entregaStatus !== null) {
          return this.entregaStatus ? 'success' : 'danger'
        }
        return 'warning'
      }
      return 'default'
    }
    return 'default'
  }

  get renderNomeRecebedor() {
    if (!this.nomeRecebedor) {
      return $.t('app.notInformed')
    }

    if (this.nomeRecebedor === '-') {
      return $.t('app.notIdentified')
    }

    return this.nomeRecebedor
  }

  get renderDocumentoRecebedor() {
    if (!this.documentoRecebedor) {
      if (this.rgRecebedor) {
        return null
      }

      return $.t('app.notInformed')
    }

    if (this.documentoRecebedor === '00000000') {
      return $.t('app.notIdentified')
    }

    if (this.isDocument(this.documentoRecebedor)) {
      return Helper.cpfOrCnpj(this.documentoRecebedor)
    }

    return $.t('app.notIdentified')
  }

  get renderRgRecebedor() {
    if (!this.rgRecebedor) {
      return null
    }

    if (this.rgRecebedor === '00000000') {
      return $.t('app.notIdentified')
    }

    if (this.isDocument(this.rgRecebedor)) {
      return Helper.cpfOrCnpj(this.rgRecebedor)
    }

    return $.t('app.notIdentified')
  }

  get auditoriaStatus() {
    if (this.auditoria && this.auditoria.$id) {
      if (this.auditoria.conforme) {
        return $.t('classes.Carga.columns.conform')
      } else {
        return $.t('classes.Carga.columns.disapprove')
      }
    }

    return '-'
  }

  get deliveryType() {
    if (this.possuiDanfe === true) {
      return this.translateColumn('comDanfe')
    }
    if (this.possuiDanfe === false) {
      return this.translateColumn('semDanfe')
    }
    return '-'
  }

  get slaPendente() {
    const idStatus = this.statusCarga && this.statusCarga.$id || 0

    const notInformed = $.t('classes.Carga.sla.notInformed')
    const expected = $.t('classes.Carga.sla.expected')
    const delayed = $.t('classes.Carga.sla.delayed')

    if (idStatus === 2) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? expected : delayed) : notInformed
    }

    return ''
  }

  get slaFinalizado() {
    const idStatus = this.statusCarga && this.statusCarga.$id || 0

    const notInformed = $.t('classes.Carga.sla.notInformed')
    const slaIn = $.t('classes.Carga.sla.slaIn')
    const slaOut = $.t('classes.Carga.sla.slaOut')
    const expected = $.t('classes.Carga.sla.expected')
    const delayed = $.t('classes.Carga.sla.delayed')

    if (idStatus === 1) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? expected : delayed) : notInformed
    } else if (idStatus === 3) {
      return this.slaStatus !== null ? (this.slaStatus ? slaIn : slaOut) : notInformed
    }

    return ''
  }

  get slaTagClass() {
    const idStatusPk = this.statusCarga && this.statusCarga.idStatusPk || 0

    if (idStatusPk === 1) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? 'success' : 'danger') : 'default'
    } else if (idStatusPk === 3) {
      return this.slaStatus !== null ? (this.slaStatus ? 'perfume' : 'warning') : 'default'
    }

    return 'default'
  }

  get slaFinalizadoTracking() {
    const idStatus = this.statusCarga && this.statusCarga.$id || 0

    const notInformed = $.t('classes.Carga.sla.notInformed')
    const slaIn = $.t('classes.Carga.sla.slaIn')
    const slaOut = $.t('classes.Carga.sla.slaOut')
    const expected = $.t('classes.Carga.sla.expected')
    const delayed = $.t('classes.Carga.sla.delayed')

    // No tracking, se o Status for Iniciado, vamos mostrar o SLA Status (no Detalhe da Carga não é exibido)
    if (idStatus === 1 || idStatus === 2) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? expected : delayed) : notInformed
    } else if (idStatus === 3) {
      return this.slaStatus !== null ? (this.slaStatus ? slaIn : slaOut) : notInformed
    }

    return ''
  }

  get slaTagClassTracking() {
    const idStatusPk = this.statusCarga && this.statusCarga.idStatusPk || 0

    if (idStatusPk === 1 || idStatusPk === 2) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? 'success' : 'danger') : 'default'
    } else if (idStatusPk === 3) {
      return this.slaStatus !== null ? (this.slaStatus ? 'perfume' : 'warning') : 'default'
    }

    return 'default'
  }

  get slaCircleClass() {
    const idStatus =  this.statusCarga && this.statusCarga.$id as DeliveryStatus || 0

    // Sem data de previsão deixar o circulo sem cor
    const notInformed = 'sla-circle'
    // Status pendente e no prazo
    const expected = 'sla-circle bg-seagreen'
    // Status pendente e em atraso
    const delayed = 'sla-circle bg-danger'
    // Status finalizado
    const finished = 'sla-circle bg-brown-grey'

    if (idStatus === 1 || idStatus === 2) {
      return this.dataPrevisao ? (moment().isBefore(moment(this.dataPrevisao)) ? expected : delayed) : notInformed
    } else if (idStatus === 3) {
      return finished
    }

    return notInformed
  }

  get attempt() {
    if (this.tentativaIndex && this.tentativaTotal) {
      return `${this.tentativaIndex}ª ${$.t('app.of')} ${this.tentativaTotal}`
    }
    return '-'
  }

  get checkinTime() {
    if (this.dataCheckIn && this.dataFinalizacao) {
      const start = moment(this.dataCheckIn)
      const end = moment(this.dataFinalizacao)

      const duration = moment.duration(end.diff(start))
      const days = Math.floor(duration.asDays())
      const hours = Math.floor(duration.asHours()) % 24
      const minutes = Math.floor(duration.asMinutes()) % 60

      return `${days}d ${hours}h ${minutes}m`
    }
    return '-'
  }

  @ResponseSerialize(Responsavel)
  responsaveis: Responsavel[] = []

  get deliveryTime() {
    // TODO: get idSistemaPk enums
    if (this.sistemaFinalizador && this.sistemaFinalizador.idSistemaPk === 2) {
      return $.t('classes.Carga.columns.baixaViaWeb')
    }
    if (this.dataInicioEntrega && this.dataFinalizacao) {
      const start = moment(this.dataInicioEntrega)
      const end = moment(this.dataFinalizacao)

      const duration = moment.duration(end.diff(start))
      const days = Math.floor(duration.asDays())
      const hours = Math.floor(duration.asHours()) % 24
      const minutes = Math.floor(duration.asMinutes()) % 60

      return `${days}d ${hours}h ${minutes}m`
    }
    return '-'
  }

  get event() {
    if (this.tipoOcorrencia && this.tipoOcorrencia.$id) {
      if (this.devolvida) {
        return DeliveryEvent.RETURNED
      }
      return DeliveryEvent.OCCURRENCE
    }
    return DeliveryEvent.NO_OCCURRENCE
  }

  get eventTranslated() {
    if (
      this.statusCarga &&
      (this.statusCarga.$id === DeliveryStatus.PENDING || this.statusCarga.$id === DeliveryStatus.STARTED)
    ) {
      return '-'
    } else if (this.event === DeliveryEvent.NO_OCCURRENCE) {
      return $.t('enums.DeliveryEvent.NO_OCCURRENCE')
    } else if (this.event === DeliveryEvent.OCCURRENCE) {
      return $.t('enums.DeliveryEvent.OCCURRENCE')
    } else if (this.event === DeliveryEvent.RETURNED) {
      return $.t('enums.DeliveryEvent.RETURNED')
    }
    return '-'
  }

  get eventTagClass() {
    if (this.event === DeliveryEvent.NO_OCCURRENCE) {
      return 'default'
    } else if (this.event === DeliveryEvent.OCCURRENCE) {
      return 'danger'
    } else if (this.event === DeliveryEvent.RETURNED) {
      return 'grapefruit'
    }
    return 'default'
  }

  get statusCargaTagClass() {
    if (this.statusCarga) {
      if (this.statusCarga.$id === DeliveryStatus.STARTED) {
        return 'perfume'
      } else if (this.statusCarga.$id === DeliveryStatus.PENDING) {
        return 'warning'
      } else if (this.statusCarga.$id === DeliveryStatus.FINISHED) {
        return 'aquamarine'
      }
    }
    return 'default'
  }

  get horarioChegadaObra() {
    if (this.cargaConcreto) return this.cargaConcreto.horarioChegadaObra
    return null
  }

  get horarioSaidaObra() {
    if (this.cargaConcreto) return this.cargaConcreto.horarioSaidaObra
    return null
  }

  get horarioChegadaCentral() {
    if (this.cargaConcreto) return this.cargaConcreto.horarioChegadaCentral
    return null
  }

  get horarioInicioDescarga() {
    if (this.cargaConcreto) return this.cargaConcreto.horarioInicioDescarga
    return null
  }

  get horarioTerminoDescarga() {
    if (this.cargaConcreto) return this.cargaConcreto.horarioTerminoDescarga
    return null
  }

  get isCargaConcreto() {
    return !!this.cargaConcreto
  }

  isDocument(val: string) {
    return !!val.match(/^(?:\d|-|\.|\/)+$/g)
  }

  async populateByDanfe(spinner = 'populateByDanfe') {
    if (this.danfe.length !== 44) return Promise.reject('Invalid DANFE')

    const fetch = async () => {
      await Helper.sleep(1000)
      const danfe = this.danfe.replace(/[^\d]+/g, '')
      await this.GET(`/user/carga/danfe/${danfe}`)
    }

    return await $.await.run(fetch, spinner)
  }

  async populateByCnpj(cnpj: string, spinner = 'populateByCnpj') {
    if (cnpj.length !== 14) return Promise.reject('Invalid CNPJ')

    const fetch = async () => {
      await Helper.sleep(1000)
      await this.destinatario.GET(`/user/carga/robo/destinatario/${cnpj}`)
    }

    return await $.await.run(fetch, spinner)
  }

  async persistCarga(model: CargaDanfeRequest, spinner = 'persistCarga') {
    model.viaPainel = true
    const fetch = async () => this.POST(`/user/carga`, model)
    return await $.await.run(fetch, spinner)
  }

  async persistFotosProcesso(model: CargaDanfeRequest, spinner = 'persistCarga') {
    model.viaPainel = true
    const fetch = async () => this.POST(`/user/carga/persist-foto-processo`, model)
    return await $.await.run(fetch, spinner)
  }

  async persistFotos(model: CargaDanfeRequest, spinner = 'persistCarga') {
    model.viaPainel = true
    const fetch = async () => this.POST(`/user/carga/persist-foto`, model)
    return await $.await.run(fetch, spinner)
  }

  async persistCargaDanfe(model: CargaDanfeRequest, spinner = 'persistCarga') {
    model.viaPainel = true

    const fetch = async () => {
      if (model.carga && model.carga.possuiDanfe === true) {
        return await this.POST(`/user/carga/cadastro-com-danfe`, model)
      } else {
        return await this.POST(`/user/carga/cadastro-sem-danfe`, model)
      }
    }

    return await $.await.run(fetch, spinner)
  }

  async getCargaSimples(id: ID, spinner = 'getCargaSimples') {
    const fetch = async () => await this.GET(`/user/carga/${id}/simplificada`)
    return await $.await.run<Resp<Carga>>(fetch, spinner)
  }

  async getCarga(id: ID, spinner = 'getCarga', ignoreErrors = false) {
    const fetch = async () => {
      if (ignoreErrors) {
        return await this.GET(`/user/carga/${id}`, {
          headers: {
            'X-Ignore-Errors': '1',
          },
        })
      } else {
        return await this.GET(`/user/carga/${id}`)
      }
    }
    return await $.await.run<Resp<Carga>>(fetch, spinner)
  }

  async getCargaByNotaFiscal(
    nroNotaFiscal: number,
    spinner = 'getCarga',
    ignoreErrors = false,
  ) {
    const fetch = async () => {
      if (ignoreErrors) {
        return await this.GET(`/user/carga/nota-fiscal/${nroNotaFiscal}`,
          { headers: { 'X-Ignore-Errors': '1' } },
          )
      } else {
        return await this.GET(`/user/carga/nota-fiscal/${nroNotaFiscal}`)
      }
    }
    return await $.await.run<Resp<Carga>>(fetch, spinner)
  }

  async setReplicarCTE() {
    await this.POST(`/user/carga/${this.idCargaPk}/carga-observacao`, this)
  }

  async setCargaStatusToPendent(request: DevolverNota) {
    await this.POST(`/user/carga/status-to-pendent`, request)
  }

  async persistTipoNotificacaoCarga(request: Carga, spinner = 'persistTipoNotificacaoCarga') {
    const fetch = async () => await new HttpBody(Number).POST(`/user/carga/persist-tipo-notificacao`, request)
    await $.await.run(fetch, spinner)
    success('system.success.persist')
  }

  get isNotificar() {
    if (!this.cargaInfo) {
      return false
    }
    return [TipoNotificacao.NOTIFICAR_PAINEL as number, TipoNotificacao.TODOS as number]
        .includes(this.cargaInfo.idTipoNotificacaoFk as number)
  }

  get nomeTipoOcorrenciaSucesso() {
    return this.cargaInfo && this.cargaInfo.tipoOcorrenciaSucesso
        ? this.cargaInfo.tipoOcorrenciaSucesso.nome : null
  }

  get showTipoFinalizacaoSucesso() {
    return Helper.getPermitirTipoFinalizacaoSucesso()
  }

  get showQtdFotosObservacaoColeta() {
    return Helper.getPermitirFotoInicioCarga()
  }

  get showIntegracaoCorreios() {
    return Helper.getPermitirIntegracaoCorreios()
  }

  get showMapaTelaSacPrivado() {
    return Helper.getExibirMapaTelaSacPrivado() ||
        this.embarcador.responsavel.exibirMapaTelaSacPrivado ||
        this.transportador.responsavel.exibirMapaTelaSacPrivado
  }

  get showPrevisaoReal() {
    return Helper.getPermitirDataReal()
  }

  get slaByDiasAtraso() {
    const expected = $.t('classes.Carga.sla.expected')
    const delayed = $.t('classes.Carga.sla.delayed')

    return this.diasAtraso && this.diasAtraso <= 0 ? expected : delayed
  }

  get slaTagByDiasAtraso() {
    return this.diasAtraso && this.diasAtraso <= 0 ? 'perfume' : 'danger'
  }

  get auditoriaStatusTagClass() {
    if (this.auditoria && this.auditoria.$id) {
      if (this.auditoria.conforme) {
        return 'aquamarine'
      } else {
        return 'danger'
      }
    }
    return 'default'
  }

  get showNotificacaoAtlas() {
    return Helper.isAtlasOrAssociates()
  }
  get tipoNotificacaoCargaContent() {
    if (this.idTipoNotificacaoCargaFk === TipoNotificacaoCarga.NOTIFICAR) {
      return $.t('app.notify')
    } else if (this.idTipoNotificacaoCargaFk === TipoNotificacaoCarga.PRIORIZAR) {
      return $.t('app.prioritize')
    }

    return ''
  }

  get observacaoEntregaContent() {
    if (this.idTipoNotificacaoCargaFk) {
      return `${this.tipoNotificacaoCargaContent} - ${this.observacaoEntrega}`
    }
    return '-'
  }
}
